export default "__VITE_ASSET__ABhLfNew__"